module.exports = __webpack_public_path__ + "img/20180815_145537_015.30c5fab3.jpg";